import {
  useAddProductToWishlist,
  useGetProductIsInWishlist,
  useRemoveProductFromWishlist,
} from '@aboutyou/legacy-shared'
import {
  contextIsAvailable,
  extractTrackingSectionContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import {
  dummyElementContext,
  getTrackingWishlistItem,
} from 'helpers/tracking/getTrackingWishlistItem'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useCallback } from 'react'
import { useLocaleStore } from 'store/context'
import Product from 'store/entities/Product/Product.store'

export const useToggleWishlistHandler = () => {
  const trackWishListToggle = useTrackWishlistToggle()

  const getProductIsInWishlist = useGetProductIsInWishlist()
  const removeProductFromWishlist = useRemoveProductFromWishlist()
  const addProductToWishlist = useAddProductToWishlist()

  const onWishListToggle = useCallback(
    async (product: Product) => {
      const wishlisted = getProductIsInWishlist({
        productId: Number(product.id),
      })

      trackWishListToggle(
        wishlisted ? 'removed-from-wishlist' : 'add-to-wishlist',
        product,
      )

      if (wishlisted) {
        await removeProductFromWishlist({ productId: Number(product.id) })
      } else {
        await addProductToWishlist({ productId: Number(product.id) })
      }
    },
    [trackWishListToggle],
  )

  return onWishListToggle
}

const useTrackWishlistToggle = () => {
  const { TrackingClient, pageContext, sectionContext } = useTracking()
  const { currency, locale } = useLocaleStore()

  return useCallback(
    (action: 'add-to-wishlist' | 'removed-from-wishlist', product: Product) => {
      if (
        product &&
        contextIsAvailable(pageContext) &&
        !pageContext.disabled &&
        contextIsAvailable(sectionContext)
      ) {
        const section = extractTrackingSectionContext(sectionContext)
        const trackingWishlistItem = getTrackingWishlistItem({
          product,
          locale,
          currency,
        })
        TrackingClient?.trackWishlistAction({
          type: action,
          section,
          element: dummyElementContext,
          wishlistItem: trackingWishlistItem,
        })
      }
    },
    [TrackingClient, currency, locale, pageContext, sectionContext],
  )
}
